module.exports = __webpack_public_path__ + "static/img/全自动测试机.59de0ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/atlas/instructionsIimags/全自动测试机.png
// module id = oQ7z
// module chunks = 1